import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SortableListComponent } from './sortable-list.component';
import { SortablejsModule } from 'ngx-sortablejs';


@NgModule({
    declarations: [
        SortableListComponent
    ],
    imports: [
        CommonModule,
        SortablejsModule.forRoot({ animation: 150 })
    ],
    exports: [
        SortableListComponent
    ]
})
export class SortableListModule { }
